// extracted by mini-css-extract-plugin
export default {"container":"OneColumnLayout-module--container--9d257","titleRow":"OneColumnLayout-module--titleRow--b2d43","breadcrumbsRow":"OneColumnLayout-module--breadcrumbsRow--25059"};